<script>
    export default {
        props: {
            load_signatureid: {
                type: Number,
                default: null,
            },
            load_employeesignatureid: {
                type: Number,
                default: null,
            },
        },
        data: function () {
            return {
                employee_email: '',
                employee_access_error: null,
            }
        },
        methods: {
            checkEmployeeAccess: function() {
                var self = this;
                self.employee_access_error = null;
                axios.post('/check-employee-access', { signatureid: this.load_signatureid, employeesignatureid: this.load_employeesignatureid, employee_email: this.employee_email } )
                .then(function (response) {
                    if (response.data.status == 'success') {
                        window.location.reload();
                    } else if (response.data.status == 'error') {
                        self.employee_access_error = response.data.message;
                    }
                })
                .catch(function (error) {
                    
                });
            }
        }
    }
</script>
